<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
				</b-col>
			</b-row>
			<b-row v-if="isUploadSuccess">
				<b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Approval History" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="approvalHistoryPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="approvalHistorys" :fields="fieldsApprovalHistory" :busy="isDataLoading" :sort-by.sync="sortByApprovalHistory" :sort-desc.sync="sortDescApprovalHistory" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowApprovalHistoryFilter = !isShowApprovalHistoryFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowApprovalHistoryFilter">
										<b-th></b-th>
										<b-th stacked-heading="Approval Instance">
											<v-select append-to-body label="approvalTag" :options="approvalInstances" :value="filterApprovalHistory.approvalInstanceId"  :reduce="item => item.id" v-model="filterApprovalHistory.approvalInstanceId" @search="getApprovalInstances" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approver Type">
											<v-select append-to-body label="name" :options="approverTypes" :value="filterApprovalHistory.approverTypeId"  :reduce="item => item.id" v-model="filterApprovalHistory.approverTypeId" @search="getApproverTypes" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approval Structure">
											<v-select append-to-body label="name" :options="approvalStructures" :value="filterApprovalHistory.approvalStructureId"  :reduce="item => item.id" v-model="filterApprovalHistory.approvalStructureId" @search="getApprovalStructures" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approver Level">
											<b-form-input id="input-approver-level-table" v-model="filterApprovalHistory.approverLevel" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Approver User Name">
											<b-form-input id="input-approver-user-name-table" v-model="filterApprovalHistory.approverUserName" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Sequenc">
											<b-form-input id="input-sequence-table" v-model="filterApprovalHistory.sequence" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Activity State">
											<v-select append-to-body label="name" :options="activityStates" :value="filterApprovalHistory.acitivtyStateId"  :reduce="item => item.id" v-model="filterApprovalHistory.acitivtyStateId" @search="getActivityStates" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approval Configuration Instance Detail">
											<v-select append-to-body label="approverType" :options="approvalConfigurationInstanceDetails" :value="filterApprovalHistory.approvalConfigurationInstanceDetailId"  :reduce="item => item.id" v-model="filterApprovalHistory.approvalConfigurationInstanceDetailId" @search="getApprovalConfigurationInstanceDetails" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Message">
											<b-form-input id="input-message-table" v-model="filterApprovalHistory.message" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Status">
											<b-form-input id="input-status-table" v-model="filterApprovalHistory.status" size="sm"></b-form-input>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( approvalHistoryPageSize * (currentApprovalHistoryPage - 1))) }}
									</template>
									<template v-slot:cell(approvalInstance)="row">
										{{ row.item.approvalInstance != null ? row.item.approvalInstance.approvalTag : "" }}
									</template>
									<template v-slot:cell(approverType)="row">
										{{ row.item.approverType != null ? row.item.approverType.name : "" }}
									</template>
									<template v-slot:cell(approvalStructure)="row">
										{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
									</template>
									<template v-slot:cell(acitivtyState)="row">
										{{ row.item.acitivtyState != null ? row.item.acitivtyState.name : "" }}
									</template>
									<template v-slot:cell(approvalConfigurationInstanceDetail)="row">
										{{ row.item.approvalConfigurationInstanceDetail != null ? row.item.approvalConfigurationInstanceDetail.approverType : "" }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentApprovalHistoryPage"
									:total-rows="totalApprovalHistoryRow"
									:per-page="approvalHistoryPageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
		</b-card>
		<template #modal-footer="{ ok, cancel }">
			<b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
				Download Log
			</b-button>
			<b-button size="sm" variant="success" class="float-right" @click="ok()">
				{{ okTitle }}
			</b-button>
			<b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
				Cancel
			</b-button>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
.card {
	border: 1px solid rgba(0, 0, 0, 0.125) !important;
}
::v-deep.th-message {
	color: red;
}
::v-deep.modal-footer {
	display: block;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate"; 
import { required, minLength } from "vuelidate/lib/validators"; 
import { saveAs } from 'file-saver';

import ApprovalHistory from '@/models/ApprovalHistory/ApprovalHistory';
import ApprovalHistoryList from '@/models/ApprovalHistory/ApprovalHistoryList';
import ApprovalHistoryFilter from '@/filters/ApprovalHistory/ApprovalHistoryFilter';

import ApprovalInstance from '@/models/ApprovalInstance/ApprovalInstance';
import ApprovalInstanceFilter from '@/filters/ApprovalInstance/ApprovalInstanceFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import ActivityState from '@/models/ActivityState/ActivityState';
import ActivityStateFilter from '@/filters/ActivityState/ActivityStateFilter';
import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';
import AppInputFileupload from '@/components/AppInputFileupload';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,AppInputDatetimepicker,AppInputDatetimepickerRange,},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fieldsApprovalHistory: [
				{"no" : { "class" : "th-number"}}, 
				{"approvalInstance": { "class" : "th-approval-instance", "label" : "Approval Instance"}, key: 'approvalInstance', sortable: true}, 
				{"approverType": { "class" : "th-approver-type", "label" : "Approver Type"}, key: 'approverType', sortable: true}, 
				{"approvalStructure": { "class" : "th-approval-structure", "label" : "Approval Structure"}, key: 'approvalStructure', sortable: true}, 
				{"approverLevel": { "class" : "th-approver-level", "label" : "Approver Level"}, key: 'approverLevel', sortable: true}, 
				{"approverUserName": { "class" : "th-approver-user-name", "label" : "Approver User Name"}, key: 'approverUserName', sortable: true}, 
				{"sequence": { "class" : "th-sequence", "label" : "Sequenc"}, key: 'sequence', sortable: true}, 
				{"acitivtyState": { "class" : "th-acitivty-state", "label" : "Activity State"}, key: 'acitivtyState', sortable: true}, 
				{"approvalConfigurationInstanceDetail": { "class" : "th-approval-configuration-instance-detail", "label" : "Approval Configuration Instance Detail"}, key: 'approvalConfigurationInstanceDetail', sortable: true}, 
				{"message": { "class" : "th-message", "label" : "Message"}, key: 'message', sortable: true}, 
				{"status": { "class" : "th-status", "label" : "Status"}, key: 'status', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isDataLoading: false,
			isBusy : false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			approvalHistorys : [],
			approvalHistoryId : '',
			totalApprovalHistoryRow : 0,
			isShowApprovalHistoryFilter: false,
			filterApprovalHistory : null,
			currentApprovalHistoryPage : 1,
			approvalHistoryPageSize: 10,
			sortByApprovalHistory: '',
			sortDescApprovalHistory: '',
			approvalInstances: [],
			approverTypes: [],
			approvalStructures: [],
			activityStates: [],
			approvalConfigurationInstanceDetails: [],
			processId: "",
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'approvalhistory/confirmUpload',
					[],
					).then(async function(response){
						if (response != null) {
						if (response.data != null) {
							_this.resetModal();
							_this.datas = Array();
							_this.fileupload = null;
							_this.isUploadSuccess = false;
						}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
				let data = new FormData();
				data.append('file', this.fileupload);
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'approvalhistory/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.isBusy = false;
						_this.isUploadSuccess = true;
						_this.getApprovalHistorys();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getApprovalHistorys : async function() {
			let filter = {};
			Object.assign(filter, this.filterApprovalHistory);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByApprovalHistory = Array();
			if (this.sortByApprovalHistory != null) {
				this.sortingByApprovalHistory[this.sortByApprovalHistory] = this.sortDescApprovalHistory;
			}
			let currentPage = (this.currentApprovalHistoryPage - 1);
			ApprovalHistory.getList(this, filter, this.sortingByApprovalHistory, currentPage , this.approvalHistoryPageSize).then(result => {
				this.approvalHistorys = result.data;
				this.totalApprovalHistoryRow = result.dataCount;
			}).catch(error => {});
		},
		getApprovalInstances : async function(input) {
			let filter = new ApprovalInstanceFilter();
			if (input != undefined) {
				filter.approvalTag = input;
			}
			ApprovalInstance.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalInstances = result.data
				}
			})
			.catch(error => {});
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getActivityStates : async function(input) {
			let filter = new ActivityStateFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ActivityState.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.activityStates = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurationInstanceDetails : async function(input) {
			let filter = new ApprovalConfigurationInstanceDetailFilter();
			if (input != undefined) {
				filter.approverType = input;
			}
			ApprovalConfigurationInstanceDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurationInstanceDetails = result.data
				}
			})
			.catch(error => {});
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		downloadLog() {
			let _this = this;
			this.$http.post(process.env.VUE_APP_API_URL + 'approvalhistory/downloadlog', [],
			{ headers: { 'Content-Type': 'application/json' }}
			).then(async function(response){
				await saveAs(process.env.VUE_APP_API_URL + 'approvalhistory/downloadlog', "ApprovalHistory.xslx");
				_this.isBusy = false;
			})
			.catch(error => {
				_this.$store.dispatch('addErrorMessageGlobal', error);
				_this.isBusy = false;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		sortByApprovalHistory : {
			handler: function() {
				this.getApprovalHistorys();
			}
		},
		sortDescApprovalHistory: {
			handler: function() {
				this.getApprovalHistorys();
			}
		},
		currentApprovalHistoryPage: {
			handler: function() {
				this.getApprovalHistorys();
			}
		},
		approvalHistoryPageSize : {
			handler: function() {
				this.getApprovalHistorys();
			}
		},
		filterApprovalHistory: {
			handler: function() {
				this.getApprovalHistorys();
			},
			deep: true,
		},
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Proses";
				}
				return "Simpan";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterApprovalHistory = new ApprovalHistoryFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
